import DefaultPipelineCard from './DefaultPipelineCard';

export default DefaultPipelineCard;
